// extracted by mini-css-extract-plugin
module.exports = {"main":"CTA_main__GsUJB"};